<script lang="ts">
	//UI
	import { Card } from "@hitit/new_ui";
	//Utils
	import { t } from "@hitit/hub/src/stores";
	//Types
	import type { UserData } from "@hitit/api";

	//Props

	export let user: UserData;
	//Constants
	const parseDefaultValue = (value: any) => value;
	const parseBooleanValue = (value?: any) => (value ? "TRUE" : "FALSE");
	const titleAndKey: {
		title: string;
		key: keyof UserData;
		callback: (v: any) => string;
	}[] = [
		{ title: "UID", key: "id", callback: parseDefaultValue },
		{ title: "AuthProvider", key: "authProvider", callback: parseDefaultValue },
		{
			title: "accountNonExpired",
			key: "accountNonExpired",
			callback: parseBooleanValue,
		},
		{
			title: "credentialsNonExpired",
			key: "credentialsNonExpired",
			callback: parseBooleanValue,
		},
		{
			title: "accountNonLocked",
			key: "accountNonLocked",
			callback: parseBooleanValue,
		},
	];
	//Variables
	//Functions
	//Do

</script>

<Card noPadding>
	<div class="container">
		<p class="title">ADDITIONAL INFO</p>
		<div class="list">
			{#each titleAndKey as { title, key, callback }}
				<div class="key-value">
					<div class="key">{$t(`mbr.user.${title}`)}</div>
					<div class="value">{callback(user[key])}</div>
				</div>
			{/each}
		</div>
	</div>
</Card>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 20px;
		padding: 16px 10px;
		color: #46474b;
		.title {
			font-weight: 500;
			font-size: 1.25rem;
		}

		.list {
			display: flex;
			flex-direction: column;
			gap: 20px;
			.key-value {
				display: flex;
				flex-direction: column;
				gap: 10px;
				.value {
					font-weight: 500;
					word-break: break-all;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			padding: 30px;
			gap: 30px;
			.title {
				font-size: 1.5rem;
			}

			.list {
				gap: 30px;
				.key-value {
					font-size: 1.25rem;
				}
			}
		}
	}

</style>
